import { apiGet } from '@/store/api';
import { useApplicationStore } from '@/store/applicationStore';

export async function getFeatureCodes() {
  const applicationStore = useApplicationStore();
  const data = await apiGet('helper/featureCodes');
  applicationStore.setFeatureCodes(data);
}